'use strict';
var angular = require('angular');

var inputSelectIntegrationCtrl = ['$timeout', function ($timeout) {
    var _this = this;
    this.focusInput = false;
    this.focusSelect = false;
    this.showSuggestionsDialog = false;
    this.suggestions = [];
    this.selectedSuggestion = null;

    // Ordenar la optionlist por 'name' alfabéticamente
    if (this.optionlist && Array.isArray(this.optionlist)) {
        this.optionlist.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
    }

    if (!this.inputId) { this.inputId = null; }
    this.selectedName = "";
    if (this.inputId) {
        let selectedOption = this.optionlist.find(option => option.id === this.inputId);
        if (selectedOption) {
            this.selectedName = selectedOption.name;
        }
    }

    this.search = function() {
        // Reset de la sugerencia activa para que volver a elegir el mismo item
        // siempre dispare el 'change' del select.
        _this.selectedSuggestion = null;
        if (!_this.selectedName) {
            _this.suggestions = _this.optionlist;
            _this.showSuggestionsDialog = true;
            return;
        }
        _this.showSuggestionsDialog = true;

        _this.suggestions = _this.optionlist.filter(function(suggestion) {
            return suggestion.name.toLowerCase().includes(_this.selectedName.toLowerCase());
        });
    };

    // Seleccionar una sugerencia
    this.selectSuggestion = function() {
        if (!_this.selectedSuggestion) {
            _this.onChange({ id: null });
            return;
        }

        _this.selectedName = _this.selectedSuggestion.name; // Muestra el name
        _this.inputId = _this.selectedSuggestion.id; // Guarda el id y lo pasa al padre
        _this.suggestions = [];
        _this.showSuggestionsDialog = false;
        _this.onChange({ id: _this.inputId });
    };

    // Manejar la tecla Enter
    this.enter = function(event) {
        if (event.keyCode === 13) { // 'Enter' key
            this.selectSuggestion();
            event.preventDefault(); // Prevents the browser's default behavior
            event.stopPropagation(); // Stops the event's propagation to prevent it from affecting other parts of the application.
        }
    };

    // The $timeout function allows select to execute "selectSuggestion" function, before hidding the select dialog
    this.onBlur = function() {    
        $timeout(() => {
            if (!_this.focusSelect) {
                _this.showSuggestionsDialog = false;
                _this.suggestions = [];
            }
            _this.focusInput = false;
            _this.focusSelect = false;
        }, 100);
    };

    // 'search' icon 
    this.searchIcon = function() {
        _this.search();
        document.getElementById('searchInput').focus();
    };

    // Clear input from 'x' icon 
    this.clearInput = function() {
        _this.selectedName = '';
        _this.inputId = null;
        _this.selectedSuggestion = null;
        _this.suggestions = [];
        _this.showSuggestionsDialog = false;
        _this.onChange({ id: null });
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            inputId: '=', // Enlace bidireccional con el padre
            optionlist: '=',
            onChange: '&',
        },
        controller: inputSelectIntegrationCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/inputSelectIntegrationDirective.html'
    };
};
